import React, { Component } from "react"
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from "prop-types"
import { CssBaseline, CircularProgress, Container, Button, Grid, Typography, Card, CardContent, Accordion, AccordionSummary, AccordionDetails, Divider } from "@mui/material"
import { withStyles } from "@mui/styles"
import { Styles } from "../../styles/material-styles"
import { Overlay } from "../../styles/global"
import CustomizedSnackbars from "../../components/material-snackbars"
import HeaderMenu from "../../components/header-menu"
import MyMaterialTable from '../../components/table'
import Api from "../../services/api"
import ApiReports from "../../services/apireport"
import * as calledsActions from '../../redux/actions/calleds'
import { AbilityContext } from '../../config/ability-context'
import Footer from '../../components/footer'
import moment from "moment"
import { FormattedMessage, injectIntl } from 'react-intl'
import SimpleDatePicker from '../../components/date-pickers/inline-no-today'
import SimpleAutoCompleteMultiple from '../../components/auto-complete/autocomplete-multiple'
import Pagination from '@mui/material/Pagination'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import LogoMarca from '../../images/new-logo-cmtech.png'

class MacroExecutionReport extends Component {
  constructor(props) {
    super(props)

    const { userSession } = this.props
    if (userSession == null || userSession.user == null)
      Api.logoff()

    this.state = {
      dateStart: moment().format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
      MacroListFilter: [],
      MacroList: [],
      
      loading: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",
      
      showGrid: false,
      macrosExecutionList: [],
      
      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0,
      
      columns: [],
    }
  }

  async componentDidMount() {
    this.setState({ loading: true })
    await this.getMacros()
    this.setState({ loading: false })
  }
  
  getMacros = async () => {
    try {
      
      const result = await Api.get('/macro') 
      
      let data = []
      if (result.data && result.data.data) {
        data = result.data.data
      } else if (result.data && Array.isArray(result.data)) {
        data = result.data
      }

      this.setState({ MacroList: data })
    } catch (err) {
      console.error("Erro ao buscar macros:", err)
      this.setState({ MacroList: [] })
    }
  }

  changeValues = (stateName, value) => {
    this.setState({ [stateName]: value, page: 1 })
  }

  onChangePaginate = (e, page) => {
    this.setState({ page: page })
    this.getReportData(page)
  }

  setPagination = (count, page) => {
    let totalPage = Math.ceil(count / 10)
    this.setState({ totalPages: totalPage })
    if (count > 0) {
      if (page === 1) {
        this.setState({ pageStart: 1, pageEnd: count < 10 ? count : 10 })
      } else {
        let pageStart = ((page - 1) * 10) + 1
        this.setState({ pageStart: pageStart, pageEnd: count >= page * 10 ? page * 10 : count })
      }
    } else {
      this.setState({ totalPages: 0, page: 1, count: 0 })
    }
  }

  getColumns() {
    const intl = this.props.intl;
    const columns = [
      { title: intl.formatMessage({ id: "macro.id" }), field: 'macro_id' },
      { title: intl.formatMessage({ id: "macro.name" }), field: 'macro_name' },
      { title: intl.formatMessage({ id: "called.number" }), field: 'called_id' },
      { 
        title: intl.formatMessage({ id: "execution.date" }), 
        field: 'executed_at',
        render: rowData => rowData.executed_at ? moment(rowData.executed_at).format('DD/MM/YYYY HH:mm:ss') : ''
      },
      { title: intl.formatMessage({ id: "execution.result" }), field: 'execution_result' },
    ];
    this.setState({ columns: columns })
  }

  getReportData = async (page = 1) => {
    const intl = this.props.intl;
    var dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    var dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')

    if (dateStart > dateEnd) {
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "report.audit.initial.date.higher.than.end.date" }),
      });
      return;
    }

    this.setState({ loading: true, macrosExecutionList: [], showGrid: false });
    
    let macroIds = "";
    if (this.state.MacroListFilter && this.state.MacroListFilter.length > 0) {
      macroIds = this.state.MacroListFilter.map(m => m.id).join(',');
    }

    let url = `/report/macroexecution/paginate?page=${page}&dateStart=${dateStart}&dateEnd=${dateEnd}&macroids=${macroIds}`

    ApiReports.get(url)
      .then(result => {
        if (result.data.success) {
          let count = result.data.count || (result.data.data ? result.data.data.length : 0);
          this.setState({ count: count, showGrid: true })
          this.setPagination(count, page)

          const formattedList = result.data.data || [];
          this.setState({ macrosExecutionList: formattedList, loading: false })
          this.getColumns()
        } else {
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: result.data?.errors?.[0] || intl.formatMessage({ id: "process.error" })
          })
        }
      })
      .catch(err => {
        this.setState({
          loading: false, openNotification: true, notificationVariant: "error",
          notificationMessage: err.response?.data?.errors?.[0] || intl.formatMessage({ id: "process.error", defaultMessage: "Ocorreu um erro no processamento." })
        })
      })
  }

  exportPlan = async () => {
    this.setState({ loading: true })

    let macroIds = "";
    if (this.state.MacroListFilter && this.state.MacroListFilter.length > 0) {
      macroIds = this.state.MacroListFilter.map(m => m.id).join(',');
    }

    let data = {
      DateStart: moment(this.state.dateStart).format('YYYY-MM-DD'),
      DateEnd: moment(this.state.dateEnd).format('YYYY-MM-DD'),
      MacroIds: macroIds
    }

    ApiReports.post(`/report/macroexecution/excell/new`, data)
      .then((response) => {
        if (response.data.success) {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: this.props.intl.formatMessage({ id: "report.sent" }) + " (" + this.props.userSession.user.email + ")"         
          });
        } else {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: response.data.errors?.[0] || this.props.intl.formatMessage({ id: "process.error", defaultMessage: "Erro no processamento." })
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: 'error',
          notificationMessage: error.response?.data?.errors?.[0] || this.props.intl.formatMessage({ id: "process.error", defaultMessage: "Erro no processamento." })
        });
      });
  }

  handleClearFilters = () => {
    this.setState({
      dateStart: moment().format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
      MacroListFilter: [],
      page: 1,
      showGrid: false,
      macrosExecutionList: []
    });
  }

  handleSubmit = e => {
    e.preventDefault();
    this.getReportData(1);
  }

  closeNotification = () => {
    this.setState({ openNotification: false });
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu, intl } = this.props

    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`
    }

    const tableList = () => {
      return (
        <>
          <form className={classes.form} onSubmit={this.handleSubmit}>
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography className={classes.heading}>{intl.formatMessage({ id: "filters", defaultMessage: "Filtros" })}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <SimpleAutoCompleteMultiple 
                      label={intl.formatMessage({ id: "macro" })}
                      options={this.state.MacroList} 
                      stateName='MacroListFilter' 
                      selected={this.state.MacroListFilter} 
                      changeSelect={this.changeValues} 
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <SimpleDatePicker 
                      label={intl.formatMessage({ id: "start.date" })} 
                      name='dateStart' 
                      stateName='dateStart' 
                      changeDate={this.changeValues} 
                      currentDate={this.state.dateStart} 
                      fullWidth={true} 
                      required 
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <SimpleDatePicker 
                      label={intl.formatMessage({ id: "end.date" })} 
                      name='dateEnd' 
                      stateName='dateEnd' 
                      changeDate={this.changeValues} 
                      currentDate={this.state.dateEnd} 
                      fullWidth={true} 
                      required 
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            <Grid container style={{ marginBottom: 10, marginTop: 10 }} spacing={2}>
              <Grid item xs={12} sm={4} md={2}>
                <Button type='submit' fullWidth variant='contained' color='secondary'>
                  <FormattedMessage id="filter"/>
                </Button>
              </Grid>
              
              <Grid item xs={12} sm={4} md={2}>
                <Button type='submit' fullWidth variant='contained' color='secondary'>
                  <FormattedMessage id="clear"/>
                </Button>
              </Grid>

              {this.state.showGrid && (
                <Grid item xs={12} sm={4} md={3}>
                  <Button fullWidth variant='contained' color='primary' onClick={this.exportPlan}>
                    <FormattedMessage id="export.plan"  />
                  </Button>
                </Grid>
              )}
            </Grid>
          </form>

          {this.state.showGrid && (
            <>
              <MyMaterialTable
                title=""
                columns={this.state.columns}
                data={this.state.macrosExecutionList} 
              />
              <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                <Grid item xs={12} md={3}>
                  <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                </Grid>
                <Grid item xs={12} sm={6} style={{ marginTop: 6 }}>
                  {this.state.pageStart} <FormattedMessage id="to"/> {this.state.pageEnd} <FormattedMessage id="of" /> {this.state.count} <FormattedMessage id="register"  />
                </Grid>
              </Grid>
            </>
          )}
        </>
      );
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })} >
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />

            <Grid container spacing={6}>
              <Grid item xs={12} sm={12}>
                <Card>
                  <CardContent className="background-title-search">
                    <Typography variant="h5">
                      <FormattedMessage id="macro.execution.report" />
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            {tableList()}

            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification} />
          </Container>
        </main>
        <Footer />
      </div>
    )
  }
}

MacroExecutionReport.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession
})

const mapDispatchToProps = dispatch => bindActionCreators(calledsActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(MacroExecutionReport)))
MacroExecutionReport.contextType = AbilityContext